import React from 'react';
import { authConfig } from '../auth/authConfig';

const LoggedOut: React.FC = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const reason = urlParams.get('reason');

    const handleLogin = () => {
        window.location.href = authConfig.apiBaseUrl + authConfig.saml.loginUrl;
    };

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <div className="text-center">
                <div className="mb-4">
                    <i className="bi bi-check-circle text-success" style={{ fontSize: '4rem' }}></i>
                </div>
                <h2 className="mb-3">Thank you for using Essentials.</h2>
                {reason === 'inactivity' ? (
                    <p className="mb-4 text-muted">Your session expired due to inactivity.</p>
                ) : (
                        <p className="mb-4 text-muted">You have successfully logged out.</p>
                )}
                <button
                    onClick={handleLogin}
                    className="btn btn-primary btn-lg"
                >
                    Sign In Again
                </button>
            </div>
        </div>
    );
};

export default LoggedOut;